import data from '@data/data.json'
import { Molecule as MoleculeData, Position } from '@interfaces/molecule'
import { Connection } from '@interfaces/connection'
import ModelMolecule from '@models/molecule'
import collect, { Collection } from 'collect.js'

export default class MoleculeRepository {
  private repository: Map<string, MoleculeData>

  constructor() {
    this.repository = new Map()

    data.molecules.forEach((molecule: MoleculeData) => {
      this.repository.set(molecule.id, molecule)
    })
  }

  public find(id: string): ModelMolecule | undefined {
    if (!this.repository.has(id)) {
      return undefined
    }

    return new ModelMolecule(this.repository.get(id) as MoleculeData)
  }

  public whereIn(key: string, values: Array<string |
    string[] |
    null |
    Position |
    Connection[] |
    number |
    boolean>): Collection<ModelMolecule> {
    return collect(
      Array.from(this.repository
        .values())
        .filter((moleculeData: MoleculeData) => values.includes(moleculeData[key]))
        .map((moleculeData: MoleculeData) => new ModelMolecule(moleculeData)),
    )
  }

  public all(): Collection<ModelMolecule> {
    return collect(
      Array.from(this.repository
        .values())
        .map((moleculeData: MoleculeData) => new ModelMolecule(moleculeData)),
    )
  }
}
